import request from '@/utils/request'

export function create(data) {

  return request({
    url: '/baseDataYEYLBTZSGBZ/create',
    method: 'POST',
    data})
}

   

export function createBatch(data) {

  return request({
    url: '/baseDataYEYLBTZSGBZ/create/batch',
    method: 'POST',
    data})
}

   

export function deleteById(data) {

  return request({
    url: '/baseDataYEYLBTZSGBZ/deleteById',
    method: 'POST',
    data})
}

   

export function deleteByIds(data) {

  return request({
    url: '/baseDataYEYLBTZSGBZ/deleteByIds',
    method: 'POST',
    data})
}

   

export function getById(params) {

  return request({
    url: '/baseDataYEYLBTZSGBZ/getById',
    method: 'GET',
    params})
}

   

export function getByIds(params) {

  return request({
    url: '/baseDataYEYLBTZSGBZ/getByIds',
    method: 'GET',
    params})
}

   

export function list(params) {

  return request({
    url: '/baseDataYEYLBTZSGBZ/list',
    method: 'GET',
    params})
}

   

export function update(data) {

  return request({
    url: '/baseDataYEYLBTZSGBZ/update',
    method: 'POST',
    data})
}

   

export function updateBatch(data) {

  return request({
    url: '/baseDataYEYLBTZSGBZ/update/batch',
    method: 'POST',
    data})
}

   